import { JetpacB2BApi } from 'api'

class B2bPaymentReciptApi {
  static addPaymentReceipt(
    faberToken: string,
    body: PaymentReceiptBackendData
  ) {
    return JetpacB2BApi.httpPost(
      'payment-receipt',
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static getPaymentRecipt(
    faberToken: string,
    params?: Record<string, string>
  ) {
    // Build query string if params provided
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''
    return JetpacB2BApi.httpGet(
      `/payment-receipt${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
}

export default B2bPaymentReciptApi

export interface PaymentReceiptBackendData {
  tenant_id: string
  payment_currency: string
  mode_of_payment: string
  payment_amount: string
  roe: string
  receipt_currency: string
  receipt_amount: string
  receipt_date: string
  receipt_particulars?: string
  deposit_ref_no: string
  remarks?: string
  created_by: string
  is_active: boolean
}

// ID                 int64     `json:"id" gorm:"column:id"`
// TenantID           int64     `json:"tenant_id,string" gorm:"column:tenant_id"`
// PaymentCurrency    string    `json:"payment_currency" gorm:"column:payment_currency"`
// ModeOfPayment      string    `json:"mode_of_payment" gorm:"column:mode_of_payment"`
// PaymentAmount      float64   `json:"payment_amount" gorm:"column:payment_amount"`
// ROE                float64   `json:"roe" gorm:"column:roe"`
// ReceiptCurrency    string    `json:"receipt_currency" gorm:"column:receipt_currency"`
// ReceiptAmount      float64   `json:"receipt_amount" gorm:"column:receipt_amount"`
// ReceiptDate        time.Time `json:"receipt_date" gorm:"column:receipt_date"`
// ReceiptParticulars string    `json:"receipt_particulars" gorm:"column:receipt_particulars"`
// DepositRefNo       string    `json:"deposit_ref_no" gorm:"column:deposit_ref_no"`
// Remarks            string    `json:"remarks" gorm:"column:remarks"`
// EmailId            string    `gorm:"-" json:"email_id"`
// IsActive           bool      `gorm:"column:is_active" json:"is_active"`
// CreatedBy          string    `gorm:"column:created_by" json:"created_by"`
// CreatedAt          time.Time `gorm:"column:created_at" json:"created_at"`
